// node_modules
import {format, parse} from 'date-fns'
import React, {useState, useEffect, useContext} from 'react'
import { Routes, Route, useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";

// primereact components
import { Dropdown } from "primereact/dropdown";
import {ToastContext} from '../../App'
import {useWS} from '../../hooks/useWS'
import {foodStationOptionsApi} from '../../redux/services/foodStationOptions'

// components
import Station from "./Station";

// redux
import {
  foodStationApi,
  useGetStationListQuery
} from '../../redux/services/foodStation';
import { useGetMeQuery } from "../../redux/services/user";
import { setLoading } from "../../redux/slices/app.slice";

// utils
import getSubdomain from "../../utils/getSubdomain";

// styles
import * as styles from "./ChefPortal.module.css";

function ChefPortal() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  
  const { data: user } = useGetMeQuery();
  
  const [readyState, setReadyState] = useState(false);
  
  const token = localStorage.getItem("access_token");
  const { ws: chefWS, setStation } = useWS({token: token, stationId: null, skipAuth: false});

  const params = useParams();
  
  const showToast = useContext(ToastContext);

  const [selectedStation, setSelectedStation] = useState(null);

  const { data: stations, isSuccess: isGetStationsSuccess, isError: isGetStationsError } =
    useGetStationListQuery(getSubdomain());

  useEffect(() => {
    dispatch(setLoading(true));
  }, []);
  
  useEffect(() => {
    if (!chefWS) return;
    
    console.log(chefWS);
    
    chefWS.addEventListener("open", (event) => {
      console.log("Connection established ", event);
      setReadyState(true);
    });
    
    chefWS.addEventListener("close", (event) => {
      console.log("Connection closed ", event);
      setReadyState(false);
    });
  }, [chefWS]);
  
  useEffect(() => {
    if (isGetStationsSuccess && chefWS) {
        const handleMessage = (event) => {
          const data = JSON.parse(event.data);

          if (data.type === "update-stations") {
            dispatch(
              foodStationApi.util.invalidateTags([{ type: "FoodStations" }])
            );
          }
        };
        
        chefWS.addEventListener("message", handleMessage);
        
        return () => {
          chefWS.removeEventListener("message", handleMessage);
        };
    }
  }, [isGetStationsSuccess, chefWS]);
  
  useEffect(() => {
    if (params["*"].length && isGetStationsSuccess) {
      const stationId = params["*"].split("/")[1];
      const station = stations.find((station) => +station.id === +stationId);
      if(station.active === 1)
        setSelectedStation(station);
      else {
        setSelectedStation(null)
        showToast('info', 'Station', 'Station is no longer active');
        navigate(`/app/chef`);
      }
    } else {
      setSelectedStation(null);
    }
    if (isGetStationsSuccess) {
      dispatch(setLoading(false));
    }
  }, [params["*"], isGetStationsSuccess, stations]);

  useEffect(() => {
    if (selectedStation) {
      navigate(`/app/chef/station/${selectedStation.id}`);
    }
  }, [selectedStation]);
  
  useEffect(() => {
    if(isGetStationsError) {
      showToast('error', 'Station', 'Unable to load stations')
      dispatch(setLoading(false));
    }
  }, [isGetStationsError]);

  return (
    <div
      className={`${styles.pageWrapper} ${
        params["*"].length ? styles.pageWithStation : ""
      }`}
    >
      <div className={styles.header}>
        {selectedStation ? (
          <h1>{selectedStation.name}</h1>
        ) : (
          <>
            <h1>
              <span>Hello, {user.username}!</span>
            </h1>
            <div>Select Station</div>
          </>
        )}
        <div className={styles.dropDownWrapper}>
          {stations?.length && (
            <Dropdown
              value={selectedStation}
              onChange={(e) => setSelectedStation(e.value)}
              options={stations?.toSorted((a, b) => {
                  if (a.active !== b.active) return b.active - a.active
                  return a.name.localeCompare(b.name)
                }
              )}
              optionDisabled={(opt) => opt.active === 0}
              optionLabel="name"
              placeholder="Select your station"
              className="w-full md:w-14rem"
              panelClassName={`${styles.dropDownPanel} ${
                params["*"].length ? styles.pageWithStation : ""
              }`}
            />
          )}
        </div>
      </div>

      {!selectedStation && (
        <div className={styles.descriptionWrapper}>
          <div className={styles.description}>
            <p>
              Today, we <span className={styles.bold}>don’t just cook</span> —
              we create experiences! Every plate is a chance to show pride,
              passion, and precision.{" "}
              <span className={styles.orange}>
                Let’s make every bite count.
              </span>
            </p>
          </div>
          <div className={styles.imageWrapper}>
            <img src="/images/chef_root_woman.png" alt="" />
          </div>
        </div>
      )}

      <div className={styles.mainWrapper}>
        <Routes>
          <Route path={"/station/:stationId"} element={<Station chefWS={chefWS} setStation={setStation} readyState={readyState} />} />
        </Routes>
      </div>
    </div>
  );
}

export default ChefPortal;
